import React, { useState } from 'react';
import axios from 'axios';
import { createStudyGroup } from '../api';
import { useNavigate } from 'react-router-dom';
import '../App.css';

const CreateStudyGroup = () => {
  const [subject, setSubject] = useState('');
  const [meetingTime, setMeetingTime] = useState('');
  const [sessionType, setSessionType] = useState('online');
  const [onlineMeetingLink, setOnlineMeetingLink] = useState('');
  const [libraryOptions, setLibraryOptions] = useState([]);
  const [selectedLibraryId, setSelectedLibraryId] = useState('');
  const [availableRooms, setAvailableRooms] = useState([]);
  const [libraryDropdownOpen, setLibraryDropdownOpen] = useState(false);
  const [loadingRoomId, setLoadingRoomId] = useState(null);

  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  let currentUser = null;
  try {
    const storedUser = localStorage.getItem("user");
    currentUser = storedUser ? JSON.parse(storedUser) : null;
  } catch (err) {
    console.error("Failed to parse user from localStorage:", err);
  }

  const LIBRARY_API_BASE = 'https://yd0w0dunk0.execute-api.us-east-1.amazonaws.com/dev/api';


  const fetchLibraries = async () => {
    try {
      const res = await axios.get(`${LIBRARY_API_BASE}/libraries/`);
      setLibraryOptions(res.data);
      setLibraryDropdownOpen(true);
    } catch (err) {
      console.error('Error fetching libraries:', err);
    }
  };

  const fetchAvailableRooms = async (libraryId) => {
    try {
      const res = await axios.get(`${LIBRARY_API_BASE}/available-rooms/?library_id=${libraryId}`);
      setAvailableRooms(res.data);
    } catch (err) {
      console.error('Error fetching available rooms:', err);
    }
  };

  const handleRoomBooking = async (room) => {
    try {
      setLoadingRoomId(room.room_number);

      const payload = {
        user: currentUser?.email,
        library_id: selectedLibraryId,
        room_number: room.room_number,
        reservation_time: meetingTime,
        start_time: "",
        end_time: ""
      };

      console.log("📦 Booking room with:", payload);

      const res = await axios.post(`${LIBRARY_API_BASE}/reserve-group-study/`, payload);

      if (res.data?.reservation_id) {
        const groupData = {
          subject,
          meeting_time: meetingTime,
          session_type: 'offline',
          location: `Library ${selectedLibraryId}, Room ${room.room_number} (Reservation ID: ${res.data.reservation_id})`
        };

        await createStudyGroup(groupData, token);
        alert("✅ Room booked and study group created!");
        navigate('/');
      } else {
        alert("Room booking failed. Try again.");
      }
    } catch (err) {
      console.error("Error booking room or creating group:", err);
      alert("❌ Booking or group creation failed.");
    } finally {
      setLoadingRoomId(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      alert("Please log in again.");
      navigate("/login");
      return;
    }

    if (sessionType === 'offline') {
      alert("Please book a room instead of using the submit button.");
      return;
    }

    const data = {
      subject,
      meeting_time: meetingTime,
      session_type: sessionType,
      online_meeting_link: onlineMeetingLink || `https://meet.jit.si/group-${Date.now()}`
    };

    try {
      await createStudyGroup(data, token);
      alert("✅ Study group created!");
      navigate('/');
    } catch (err) {
      console.error(err);
      alert("Error creating study group.");
    }
  };

  return (
    <div className="container">
      <h1>Create Study Group</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Subject:</label>
          <input type="text" value={subject} onChange={(e) => setSubject(e.target.value)} required />
        </div>

        <div>
          <label>Meeting Time:</label>
          <input type="datetime-local" value={meetingTime} onChange={(e) => setMeetingTime(e.target.value)} required />
        </div>

        <div>
          <label>Session Type:</label>
          <div>
            <input
              type="radio"
              id="online"
              name="sessionType"
              value="online"
              checked={sessionType === 'online'}
              onChange={() => setSessionType('online')}
            />
            <label htmlFor="online">Online</label>
          </div>
          <div>
            <input
              type="radio"
              id="offline"
              name="sessionType"
              value="offline"
              checked={sessionType === 'offline'}
              onChange={() => setSessionType('offline')}
            />
            <label htmlFor="offline">Offline</label>
          </div>
        </div>

        {sessionType === 'online' && (
          <div>
            <label>Online Meeting Link (Optional):</label>
            <input
              type="text"
              value={onlineMeetingLink}
              onChange={(e) => setOnlineMeetingLink(e.target.value)}
              placeholder="Leave blank for auto-generation"
            />
          </div>
        )}

        {sessionType === 'offline' && (
          <div>
            <label>Library</label>
            <input
              type="text"
              placeholder="Click to select library"
              readOnly
              onClick={fetchLibraries}
            />
            {libraryDropdownOpen && (
              <ul className="dropdown">
                {libraryOptions.map(lib => (
                  <li
                    key={lib.id}
                    onClick={() => {
                      setSelectedLibraryId(lib.id);
                      setLibraryDropdownOpen(false);
                      fetchAvailableRooms(lib.id);
                    }}
                  >
                    {lib.name}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}

        {sessionType === 'offline' && availableRooms.length > 0 && (
          <div style={{ marginTop: '30px' }}>
            <h3>Available Rooms</h3>
            <div className="room-cards">
              {availableRooms.map(room => (
                <div key={room.room_number} className="card">
                  <h4>Room {room.room_number}</h4>
                  <p>Available: {room.available ? "Yes" : "No"}</p>
                  <button
                    onClick={() => handleRoomBooking(room)}
                    disabled={loadingRoomId === room.room_number}
                  >
                    {loadingRoomId === room.room_number ? "Booking..." : "Book This Room"}
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        {sessionType === 'online' && (
          <button type="submit">Create</button>
        )}
      </form>
    </div>
  );
};

export default CreateStudyGroup;   